// // import React, { useState, useEffect } from "react";
// // import {
// //   TextField,
// //   Button,
// //   Typography,
// //   Box,
// //   MenuItem,
// //   Select,
// //   InputLabel,
// //   FormControl,
// //   CircularProgress,
// //   Alert,
// // } from "@mui/material";
// // import {   Card, CardContent } from "@mui/material";
// // import { CloudUpload } from "@mui/icons-material";
// // import { createShort } from "../../../services/reporterService"; 
// // import {
// //   getCountries,
// //   getStatesByCountry,
// //   getCitiesByState
// // } from "../../../services/apiService";
// // import {
// //   getCategories,
// //   getSubcategories
// // } from "../../../services/apiService";

// // const CreateShort = () => {
// //   const [title, setTitle] = useState("");
// //   const [description, setDescription] = useState("");
// //   const [category, setCategory] = useState("");
// //   const [subCategory, setSubCategory] = useState("");
// //   const [country, setCountry] = useState("");
// //   const [state, setState] = useState("");
// //   const [city, setCity] = useState("");
// //   const [videoFile, setVideoFile] = useState(null);
// //   // const [thumbnailFile, setThumbnailFile] = useState(null);

// //   const [loading, setLoading] = useState(false);
// //   const [successMsg, setSuccessMsg] = useState("");
// //   const [errorMsg, setErrorMsg] = useState("");

// //   // Categories/Subcategories
// //   const [categories, setCategories] = useState([]);
// //   const [subCategories, setSubCategories] = useState([]);

// //   // Countries/States/Cities
// //   const [countries, setCountries] = useState([]);
// //   const [states, setStates] = useState([]);
// //   const [cities, setCities] = useState([]);

// //   // Fetch all categories and countries on mount
// //   useEffect(() => {
// //     const fetchCategoriesAndCountries = async () => {
// //       try {
// //         const catRes = await getCategories();
// //         setCategories(catRes.data || []);
// //       } catch (err) {
// //         console.error("Failed to fetch categories:", err);
// //       }
// //       try {
// //         const countryRes = await getCountries();
// //         setCountries(countryRes.data || []);
// //       } catch (err) {
// //         console.error("Failed to fetch countries:", err);
// //       }
// //     };
// //     fetchCategoriesAndCountries();
// //   }, []);

// //   // Fetch subcategories when category changes
// //   useEffect(() => {
// //     if (!category) return;
// //     const fetchSubcategories = async () => {
// //       try {
// //         const catObj = categories.find(c => c.name === category);
// //         if (!catObj) return;
// //         const res = await getSubcategories(catObj._id);
// //         setSubCategories(res.data || []);
// //         setSubCategory(""); // reset subcategory selection
// //       } catch (err) {
// //         console.error("Failed to fetch subcategories:", err);
// //       }
// //     };
// //     fetchSubcategories();
// //   }, [category, categories]);

// //   // Fetch states when country changes
// //   useEffect(() => {
// //     if (!country) return;
// //     const fetchStates = async () => {
// //       try {
// //         const countryObj = countries.find(c => c.name === country);
// //         if (!countryObj) return;
// //         const res = await getStatesByCountry(countryObj._id);
// //         setStates(res.data || []);
// //         setState("");
// //         setCities([]);
// //         setCity("");
// //       } catch (err) {
// //         console.error("Failed to fetch states:", err);
// //       }
// //     };
// //     fetchStates();
// //   }, [country, countries]);

// //   // Fetch cities when state changes
// //   useEffect(() => {
// //     if (!state) return;
// //     const fetchCities = async () => {
// //       try {
// //         const stateObj = states.find(s => s.name === state);
// //         if (!stateObj) return;
// //         const res = await getCitiesByState(stateObj._id);
// //         setCities(res.data || []);
// //         setCity("");
// //       } catch (err) {
// //         console.error("Failed to fetch cities:", err);
// //       }
// //     };
// //     fetchCities();
// //   }, [state, states]);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!title || !videoFile) {
// //       setErrorMsg("Title and video file are required.");
// //       return;
// //     }
// //     setLoading(true);
// //     setErrorMsg("");
// //     setSuccessMsg("");

// //     try {
// //       const formData = new FormData();
// //       formData.append("title", title);
// //       formData.append("description", description);
// //       formData.append("category", category);
// //       formData.append("subCategory", subCategory);
// //       formData.append("country", country);
// //       formData.append("state", state);
// //       formData.append("city", city);
// //       formData.append("video", videoFile);
// //       // if (thumbnailFile) formData.append("thumbnail", thumbnailFile);

// //       const response = await createShort(formData);
// //       setSuccessMsg(response.data.message || "Short created successfully!");
// //       // Reset form
// //       setTitle(""); setDescription(""); setCategory(""); setSubCategory("");
// //       setCountry(""); setState(""); setCity("");
// //       setVideoFile(null);
// //       //  setThumbnailFile(null);
// //     } catch (error) {
// //       console.error("Failed to create short:", error);
// //       setErrorMsg(error.response?.data?.message || "Failed to create short.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Box sx={{ p: 4, maxWidth: 700, mx: "auto" }}>
// //       <Typography variant="h5" gutterBottom>Create New Short</Typography>
// //       {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}
// //       {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}

// //       <form onSubmit={handleSubmit} encType="multipart/form-data">
// //         <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} fullWidth required sx={{ mb: 2 }} />
// //         <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={4} sx={{ mb: 2 }} />

// //         {/* Category / Subcategory */}
// //         <FormControl fullWidth sx={{ mb: 2 }}>
// //           <InputLabel>Category</InputLabel>
// //           <Select value={category} onChange={(e) => setCategory(e.target.value)}>
// //             {categories.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
// //           </Select>
// //         </FormControl>
// // {/* 
// //         <FormControl fullWidth sx={{ mb: 2 }}>
// //           <InputLabel>Sub Category</InputLabel>
// //           <Select value={subCategory} onChange={(e) => setSubCategory(e.target.value)} disabled={!subCategories.length}>
// //             {subCategories.map((s) => <MenuItem key={s._id} value={s.name}>{s.name}</MenuItem>)}
// //           </Select>
// //         </FormControl> */}

// //         {/* Location
// //         <FormControl fullWidth sx={{ mb: 2 }}>
// //           <InputLabel>Country</InputLabel>
// //           <Select value={country} onChange={(e) => setCountry(e.target.value)}>
// //             {countries.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
// //           </Select>
// //         </FormControl> */}

// //         {/* <FormControl fullWidth sx={{ mb: 2 }}>
// //           <InputLabel>State</InputLabel>
// //           <Select value={state} onChange={(e) => setState(e.target.value)} disabled={!states.length}>
// //             {states.map((s) => <MenuItem key={s._id} value={s.name}>{s.name}</MenuItem>)}
// //           </Select>
// //         </FormControl> */}

// //         {/* <FormControl fullWidth sx={{ mb: 2 }}>
// //           <InputLabel>City</InputLabel>
// //           <Select value={city} onChange={(e) => setCity(e.target.value)} disabled={!cities.length}>
// //             {cities.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
// //           </Select>
// //         </FormControl> */}

// //         {/* File uploads */}
// //       <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
// //       <CardContent>
// //         <Typography
// //           variant="subtitle1"
// //           fontWeight={600}
// //           gutterBottom
// //           sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
// //         >
// //           Upload Video *
// //         </Typography>

// //         <Box
// //           sx={{
// //             border: "2px dashed #1976d2",
// //             borderRadius: 2,
// //             p: { xs: 2, sm: 3 },
// //             textAlign: "center",
// //             cursor: "pointer",
// //             "&:hover": { backgroundColor: "#f5f9ff" },
// //           }}
// //         >
// //           <input
// //             type="file"
// //             accept="video/*"
// //             id="video-upload"
// //             style={{ display: "none" }}
// //             onChange={(e) => setVideoFile(e.target.files[0])}
// //           />
// //           <label htmlFor="video-upload">
// //             <Button
// //               component="span"
// //               startIcon={<CloudUpload />}
// //               variant="contained"
// //               sx={{
// //                 borderRadius: 2,
// //                 px: { xs: 2, sm: 3 },
// //                 py: { xs: 1, sm: 1.2 },
// //                 width: { xs: "100%", sm: "auto" }, // ✅ Mobile pe full width
// //               }}
// //             >
// //               Choose Video
// //             </Button>
// //           </label>

// //           {videoFile && (
// //             <Typography
// //               mt={2}
// //               variant="body2"
// //               color="text.secondary"
// //               sx={{
// //                 fontSize: { xs: "0.8rem", sm: "0.9rem" },
// //                 wordBreak: "break-word", // ✅ Mobile pe file name wrap
// //               }}
// //             >
// //               Selected: {videoFile.name}
// //             </Typography>
// //           )}
// //         </Box>
// //       </CardContent>
// //     </Card>

// //         <Button type="submit" variant="contained" color="primary" disabled={loading}>
// //           {loading ? <CircularProgress size={24} /> : "Create Short"}
// //         </Button>
// //       </form>
// //     </Box>
// //   );
// // };

// // export default CreateShort;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   TextField,
//   Button,
//   Typography,
//   Box,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   CircularProgress,
//   Alert,
//   IconButton,
// } from "@mui/material";
// import { Card, CardContent } from "@mui/material";
// import { CloudUpload, ArrowBack } from "@mui/icons-material";
// import { createShort } from "../../../services/reporterService";
// import {
//   getCountries,
//   getStatesByCountry,
//   getCitiesByState
// } from "../../../services/apiService";
// import {
//   getCategories,
//   getSubcategories
// } from "../../../services/apiService";

// const CreateShort = () => {
//   const navigate = useNavigate();

//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [category, setCategory] = useState("");
//   const [subCategory, setSubCategory] = useState("");
//   const [country, setCountry] = useState("");
//   const [state, setState] = useState("");
//   const [city, setCity] = useState("");
//   const [videoFile, setVideoFile] = useState(null);
//   // const [thumbnailFile, setThumbnailFile] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [successMsg, setSuccessMsg] = useState("");
//   const [errorMsg, setErrorMsg] = useState("");

//   // Categories/Subcategories
//   const [categories, setCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);

//   // Countries/States/Cities
//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);

//   // Fetch all categories and countries on mount
//   useEffect(() => {
//     const fetchCategoriesAndCountries = async () => {
//       try {
//         const catRes = await getCategories();
//         setCategories(catRes.data || []);
//       } catch (err) {
//         console.error("Failed to fetch categories:", err);
//       }
//       try {
//         const countryRes = await getCountries();
//         setCountries(countryRes.data || []);
//       } catch (err) {
//         console.error("Failed to fetch countries:", err);
//       }
//     };
//     fetchCategoriesAndCountries();
//   }, []);

//   // Fetch subcategories when category changes
//   useEffect(() => {
//     if (!category) return;
//     const fetchSubcategories = async () => {
//       try {
//         const catObj = categories.find(c => c.name === category);
//         if (!catObj) return;
//         const res = await getSubcategories(catObj._id);
//         setSubCategories(res.data || []);
//         setSubCategory(""); // reset subcategory selection
//       } catch (err) {
//         console.error("Failed to fetch subcategories:", err);
//       }
//     };
//     fetchSubcategories();
//   }, [category, categories]);

//   // Fetch states when country changes
//   useEffect(() => {
//     if (!country) return;
//     const fetchStates = async () => {
//       try {
//         const countryObj = countries.find(c => c.name === country);
//         if (!countryObj) return;
//         const res = await getStatesByCountry(countryObj._id);
//         setStates(res.data || []);
//         setState("");
//         setCities([]);
//         setCity("");
//       } catch (err) {
//         console.error("Failed to fetch states:", err);
//       }
//     };
//     fetchStates();
//   }, [country, countries]);

//   // Fetch cities when state changes
//   useEffect(() => {
//     if (!state) return;
//     const fetchCities = async () => {
//       try {
//         const stateObj = states.find(s => s.name === state);
//         if (!stateObj) return;
//         const res = await getCitiesByState(stateObj._id);
//         setCities(res.data || []);
//         setCity("");
//       } catch (err) {
//         console.error("Failed to fetch cities:", err);
//       }
//     };
//     fetchCities();
//   }, [state, states]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!title || !videoFile) {
//       setErrorMsg("Title and video file are required.");
//       return;
//     }
//     setLoading(true);
//     setErrorMsg("");
//     setSuccessMsg("");

//     try {
//       const formData = new FormData();
//       formData.append("title", title);
//       formData.append("description", description);
//       formData.append("category", category);
//       formData.append("subCategory", subCategory);
//       formData.append("country", country);
//       formData.append("state", state);
//       formData.append("city", city);
//       formData.append("video", videoFile);
//       // if (thumbnailFile) formData.append("thumbnail", thumbnailFile);

//       const response = await createShort(formData);
//       setSuccessMsg(response.data.message || "Short created successfully!");
//       // Reset form
//       setTitle(""); setDescription(""); setCategory(""); setSubCategory("");
//       setCountry(""); setState(""); setCity("");
//       setVideoFile(null);
//       //  setThumbnailFile(null);
//     } catch (error) {
//       console.error("Failed to create short:", error);
//       setErrorMsg(error.response?.data?.message || "Failed to create short.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ p: 4, maxWidth: 700, mx: "auto" }}>
//       {/* ---- Back Button ---- */}
//       <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{
//             mr: 1,
//             bgcolor: "#f1f3f4",
//             "&:hover": { bgcolor: "#e0e0e0" },
//           }}
//         >
//           <ArrowBack />
//         </IconButton>
//         <Typography variant="body1" fontWeight={500} color="text.secondary">
//           Back
//         </Typography>
//       </Box>

//       <Typography variant="h5" gutterBottom>Create New Short</Typography>
//       {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}
//       {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}

//       <form onSubmit={handleSubmit} encType="multipart/form-data">
//         <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} fullWidth required sx={{ mb: 2 }} />
//         <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={4} sx={{ mb: 2 }} />

//         {/* Category / Subcategory */}
//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel>Category</InputLabel>
//           <Select value={category} onChange={(e) => setCategory(e.target.value)}>
//             {categories.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
//           </Select>
//         </FormControl>
// {/* 
//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel>Sub Category</InputLabel>
//           <Select value={subCategory} onChange={(e) => setSubCategory(e.target.value)} disabled={!subCategories.length}>
//             {subCategories.map((s) => <MenuItem key={s._id} value={s.name}>{s.name}</MenuItem>)}
//           </Select>
//         </FormControl> */}

//         {/* Location
//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel>Country</InputLabel>
//           <Select value={country} onChange={(e) => setCountry(e.target.value)}>
//             {countries.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
//           </Select>
//         </FormControl> */}

//         {/* <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel>State</InputLabel>
//           <Select value={state} onChange={(e) => setState(e.target.value)} disabled={!states.length}>
//             {states.map((s) => <MenuItem key={s._id} value={s.name}>{s.name}</MenuItem>)}
//           </Select>
//         </FormControl> */}

//         {/* <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel>City</InputLabel>
//           <Select value={city} onChange={(e) => setCity(e.target.value)} disabled={!cities.length}>
//             {cities.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
//           </Select>
//         </FormControl> */}

//         {/* File uploads */}
//       <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
//       <CardContent>
//         <Typography
//           variant="subtitle1"
//           fontWeight={600}
//           gutterBottom
//           sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
//         >
//           Upload Video *
//         </Typography>

//         <Box
//           sx={{
//             border: "2px dashed #1976d2",
//             borderRadius: 2,
//             p: { xs: 2, sm: 3 },
//             textAlign: "center",
//             cursor: "pointer",
//             "&:hover": { backgroundColor: "#f5f9ff" },
//           }}
//         >
//           <input
//             type="file"
//             accept="video/*"
//             id="video-upload"
//             style={{ display: "none" }}
//             onChange={(e) => setVideoFile(e.target.files[0])}
//           />
//           <label htmlFor="video-upload">
//             <Button
//               component="span"
//               startIcon={<CloudUpload />}
//               variant="contained"
//               sx={{
//                 borderRadius: 2,
//                 px: { xs: 2, sm: 3 },
//                 py: { xs: 1, sm: 1.2 },
//                 width: { xs: "100%", sm: "auto" }, // ✅ Mobile pe full width
//               }}
//             >
//               Choose Video
//             </Button>
//           </label>

//           {videoFile && (
//             <Typography
//               mt={2}
//               variant="body2"
//               color="text.secondary"
//               sx={{
//                 fontSize: { xs: "0.8rem", sm: "0.9rem" },
//                 wordBreak: "break-word", // ✅ Mobile pe file name wrap
//               }}
//             >
//               Selected: {videoFile.name}
//             </Typography>
//           )}
//         </Box>
//       </CardContent>
//     </Card>

//         <Button type="submit" variant="contained" color="primary" disabled={loading}>
//           {loading ? <CircularProgress size={24} /> : "Create Short"}
//         </Button>
//       </form>
//     </Box>
//   );
// };

// export default CreateShort;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  Alert,
  IconButton,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import { CloudUpload, ArrowBack, PhotoCamera } from "@mui/icons-material";
import { createShort } from "../../../services/reporterService";
import {
  getCountries,
  getStatesByCountry,
  getCitiesByState,
  getCategories,
  getSubcategories
} from "../../../services/apiService";

const CreateShort = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [videoFile, setVideoFile] = useState(null);

  // ✅ Thumbnail state added
  const [thumbnailFile, setThumbnailFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // Categories/Subcategories
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  // Countries/States/Cities
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // Fetch all categories and countries on mount
  useEffect(() => {
    const fetchCategoriesAndCountries = async () => {
      try {
        const catRes = await getCategories();
        setCategories(catRes.data || []);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }

      try {
        const countryRes = await getCountries();
        setCountries(countryRes.data || []);
      } catch (err) {
        console.error("Failed to fetch countries:", err);
      }
    };

    fetchCategoriesAndCountries();
  }, []);

  // Fetch subcategories when category changes
  useEffect(() => {
    if (!category) return;

    const fetchSubcategories = async () => {
      try {
        const catObj = categories.find(c => c.name === category);
        if (!catObj) return;

        const res = await getSubcategories(catObj._id);
        setSubCategories(res.data || []);
        setSubCategory("");
      } catch (err) {
        console.error("Failed to fetch subcategories:", err);
      }
    };

    fetchSubcategories();
  }, [category, categories]);

  // Fetch states when country changes
  useEffect(() => {
    if (!country) return;

    const fetchStates = async () => {
      try {
        const countryObj = countries.find(c => c.name === country);
        if (!countryObj) return;

        const res = await getStatesByCountry(countryObj._id);
        setStates(res.data || []);
        setState("");
        setCities([]);
        setCity("");
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };

    fetchStates();
  }, [country, countries]);

  // Fetch cities when state changes
  useEffect(() => {
    if (!state) return;

    const fetchCities = async () => {
      try {
        const stateObj = states.find(s => s.name === state);
        if (!stateObj) return;

        const res = await getCitiesByState(stateObj._id);
        setCities(res.data || []);
        setCity("");
      } catch (err) {
        console.error("Failed to fetch cities:", err);
      }
    };

    fetchCities();
  }, [state, states]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !videoFile) {
      setErrorMsg("Title and video file are required.");
      return;
    }

    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const formData = new FormData();

      formData.append("title", title);
      formData.append("description", description);
      formData.append("category", category);
      formData.append("subCategory", subCategory);
      formData.append("country", country);
      formData.append("state", state);
      formData.append("city", city);
      formData.append("video", videoFile);

      // ✅ Thumbnail added
      if (thumbnailFile) {
        formData.append("thumbnail", thumbnailFile);
      }

      const response = await createShort(formData);

      setSuccessMsg(
        response.data.message || "Short created successfully!"
      );

      // Reset form
      setTitle("");
      setDescription("");
      setCategory("");
      setSubCategory("");
      setCountry("");
      setState("");
      setCity("");
      setVideoFile(null);

      // ✅ Reset thumbnail
      setThumbnailFile(null);

    } catch (error) {
      console.error("Failed to create short:", error);

      setErrorMsg(
        error.response?.data?.message || "Failed to create short."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 700, mx: "auto" }}>

      {/* ---- Back Button ---- */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            mr: 1,
            bgcolor: "#f1f3f4",
            "&:hover": { bgcolor: "#e0e0e0" },
          }}
        >
          <ArrowBack />
        </IconButton>

        <Typography
          variant="body1"
          fontWeight={500}
          color="text.secondary"
        >
          Back
        </Typography>
      </Box>

      <Typography variant="h5" gutterBottom>
        Create New Short
      </Typography>

      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}

      <form onSubmit={handleSubmit} encType="multipart/form-data">

        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          required
          sx={{ mb: 2 }}
        />

        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          rows={4}
          sx={{ mb: 2 }}
        />

        {/* Category / Subcategory */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Category</InputLabel>

          <Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {categories.map((c) => (
              <MenuItem key={c._id} value={c.name}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Sub Category */}
        {/*
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Sub Category</InputLabel>

          <Select
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            disabled={!subCategories.length}
          >
            {subCategories.map((s) => (
              <MenuItem key={s._id} value={s.name}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        */}

        {/* Location */}
        {/*
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Country</InputLabel>

          <Select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            {countries.map((c) => (
              <MenuItem key={c._id} value={c.name}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        */}

        {/*
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>State</InputLabel>

          <Select
            value={state}
            onChange={(e) => setState(e.target.value)}
            disabled={!states.length}
          >
            {states.map((s) => (
              <MenuItem key={s._id} value={s.name}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        */}

        {/*
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>City</InputLabel>

          <Select
            value={city}
            onChange={(e) => setCity(e.target.value)}
            disabled={!cities.length}
          >
            {cities.map((c) => (
              <MenuItem key={c._id} value={c.name}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        */}

        {/* ================= VIDEO UPLOAD ================= */}

        <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
          <CardContent>

            <Typography
              variant="subtitle1"
              fontWeight={600}
              gutterBottom
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem"
                }
              }}
            >
              Upload Video *
            </Typography>

            <Box
              sx={{
                border: "2px dashed #1976d2",
                borderRadius: 2,
                p: {
                  xs: 2,
                  sm: 3
                },
                textAlign: "center",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f5f9ff"
                },
              }}
            >
              <input
                type="file"
                accept="video/*"
                id="video-upload"
                style={{ display: "none" }}
                onChange={(e) =>
                  setVideoFile(e.target.files[0])
                }
              />

              <label htmlFor="video-upload">

                <Button
                  component="span"
                  startIcon={<CloudUpload />}
                  variant="contained"
                  sx={{
                    borderRadius: 2,
                    px: {
                      xs: 2,
                      sm: 3
                    },
                    py: {
                      xs: 1,
                      sm: 1.2
                    },
                    width: {
                      xs: "100%",
                      sm: "auto"
                    },
                  }}
                >
                  Choose Video
                </Button>

              </label>

              {videoFile && (
                <Typography
                  mt={2}
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: {
                      xs: "0.8rem",
                      sm: "0.9rem"
                    },
                    wordBreak: "break-word",
                  }}
                >
                  Selected: {videoFile.name}
                </Typography>
              )}

            </Box>

          </CardContent>
        </Card>

        {/* ================= THUMBNAIL UPLOAD ================= */}

        <Card
          sx={{
            mb: 3,
            borderRadius: 3,
            boxShadow: 3
          }}
        >
          <CardContent>

            <Typography
              variant="subtitle1"
              fontWeight={600}
              gutterBottom
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem"
                }
              }}
            >
              Upload Thumbnail (Cover Image)
            </Typography>

            <Box
              sx={{
                border: "2px dashed #ed6c02",
                borderRadius: 2,
                p: {
                  xs: 2,
                  sm: 3
                },
                textAlign: "center",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#fffcf5"
                },
              }}
            >

              <input
                type="file"
                accept="image/*"
                id="thumbnail-upload"
                style={{ display: "none" }}
                onChange={(e) =>
                  setThumbnailFile(e.target.files[0])
                }
              />

              <label htmlFor="thumbnail-upload">

                <Button
                  component="span"
                  color="warning"
                  startIcon={<PhotoCamera />}
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    px: {
                      xs: 2,
                      sm: 3
                    },
                    py: {
                      xs: 1,
                      sm: 1.2
                    },
                    width: {
                      xs: "100%",
                      sm: "auto"
                    },
                  }}
                >
                  Choose Thumbnail
                </Button>

              </label>

              {thumbnailFile && (
                <Typography
                  mt={2}
                  variant="body2"
                  color="success.main"
                  sx={{
                    fontSize: {
                      xs: "0.8rem",
                      sm: "0.9rem"
                    },
                    wordBreak: "break-word",
                  }}
                >
                  Selected: {thumbnailFile.name}
                </Typography>
              )}

            </Box>

          </CardContent>
        </Card>

        {/* ================= SUBMIT ================= */}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            "Create Short"
          )}
        </Button>

      </form>
    </Box>
  );
};

export default CreateShort;

